import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../context.js';

import Helmet from "../../components/helmet.js";
import { PhysicianAvatar, Status, Button, Counter } from '../../components/component.js';
import { Image } from "../../components/filePreview.js";

function ProfileSettings() {
  const context = useContext(AppContext);
  
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Profile states
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);

  const fileUploadRef = useRef(null);

  // Security states
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPassword, setRepeatNewPassword] = useState("");

  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.post('/api/admin/physicians', {
        filter: {
          id: [context.id],
        }
      }),
      axios.get('/api/admin/settings', {
      }),
    ]).then(axios.spread((physicians, settings) => {
      setUser(physicians.data.physicians[0]);
      setSettings(settings.data);
      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  // Logo
  function triggerFileInput() {
    fileUploadRef.current.click();
  }

  function changeFileInput(e) {
    var data = new FormData();

    data.append('image', e.target.files[0]);
    data.append('userID', context.id);
    
    let u = context.addSpiner();
    axios.post('/api/admin/physicians/updateProfileImage', data).then((response) => {
      setUser((prevUser) => ({
        ...prevUser,
        profileImageID: response.data.profileImageID,
      }));
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
      // Reset the file input so subsequent uploads trigger onChange
      e.target.value = '';
    });
  }

  function save() {
    let u = context.addSpiner();
    axios.post('/api/admin/physicians/updatePassword', {
      password: password,
      new: newPassword,
      repeat: repeatNewPassword
    }).then((response) => {
      //setProject({ ...project, summaryPublic: text });
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Profile | Settings" />

      <input ref={fileUploadRef} type="file" className="d-none" onChange={changeFileInput} accept=".jpg,.jpeg,.png,.tiff" multiple={false} />

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-between align-items-center">
                <span className="typo-hero-small">Profile Settings</span>
                {/* <span className="typo-normal-175 mt-2 ms-3">Tracks program attrition metrics, including total enrollment, cases awaiting start, active projects, completed projects, and patient exits</span> */}
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} background={'none'} fill={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="col-xs-12">
          <div className="card mb-3">
            <div className="card-header sm">
              <div className="typo-strong-300">Personal information</div>
            </div>
            <div className="card-content sm">
              <div className="row">
                <div className="col-xs-6">
                  <div className="typo-strong-125 mb-1">Profile Image</div>
                  { user.profileImageID ? (
                    <Image id={user.profileImageID} onClick={triggerFileInput} alt="Profile Image" style={{height: 50, width: 50}} />
                  ) : (
                    <PhysicianAvatar id={user.id} onClick={triggerFileInput} alt="logo" style={{height: 50, width: 50}} />
                  )}
                  <div className="typo-normal-125 text-muted mt-1">Click to upload a new image. Update could take up to 5 minutes.</div>
                </div>
              </div>
              {/* <div className="row mt-3">
                <div className="col-xs-12 text-end">
                  <Button onClick={() => {}} color="white" text="Change password" />
                </div>
              </div> */}

              {/* <Button onClick={save} color="blue" text="Save" /> */}
            </div>
          </div>

          <div className="card">
            <div className="card-header sm">
              <div className="d-flex justify-content-between align-items-center">
                <div className="typo-strong-300">Security</div>
                {/* <div className="item typo-normal-150 ms-2"><UserPlus height={16} width={16} background={'none'} fill={'grey'} /> Create User</div> */}
              </div>
            </div>
            <div className="card-content sm">
              <div className="row">
                <div className="col-xs-3">
                  <div className="typo-normal-175">Current password</div>
                  <input type="password" placeholder="******" value={password} onChange={(e) => setPassword(e.target.value)} className="input borderless typo-normal-175 w-100" />
                </div>
                <div className="col-xs-3">
                  <div className="typo-normal-175">New password</div>
                  <input type="password" placeholder="******" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="input borderless typo-normal-175 w-100" />
                </div>
                <div className="col-xs-3">
                  <div className="typo-normal-175">Repeat new password</div>
                  <input type="password" placeholder="******" value={repeatNewPassword} onChange={(e) => setRepeatNewPassword(e.target.value)} className="input borderless typo-normal-175 w-100" />
                </div>
                <div className="col-xs-3">
                  <Button onClick={save} color="white" text="Change password" />
                </div>
              </div>

              {/* <Button onClick={save} color="blue" text="Save" /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileSettings;